import React from "react";
import Typography from "@mui/material/Typography";

export const Help = (props) => {
  return (
    <Typography sx={{ mt: "1em", ml: "2em" }} color="primary">
      Coming soon...
    </Typography>
  );
};
